/* Builds navigational anchors from existing article headings; it does not replace or hide source content. */
(function () {
  function slugify(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function buildArticleToc() {
    var article = document.querySelector('.rawwtr-article');
    var nav = document.querySelector('[data-rawwtr-article-toc]');
    var body = document.querySelector('.rawwtr-article__body');
    if (!article || !nav || !body) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (headings.length < 2) {
      nav.hidden = true;
      return;
    }

    var used = {};
    var list = document.createElement('ol');
    list.className = 'rawwtr-article__toc-list';

    headings.forEach(function (heading, index) {
      var seed = heading.id || slugify(heading.textContent || '') || ('section-' + (index + 1));
      var id = seed;
      var count = 2;
      while (used[id] || document.querySelectorAll('#' + CSS.escape(id)).length > (heading.id === id ? 1 : 0)) {
        id = seed + '-' + count;
        count += 1;
      }
      used[id] = true;
      heading.id = id;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });

    nav.appendChild(list);
    nav.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildArticleToc, { once: true });
  } else {
    buildArticleToc();
  }
})();
